import { Injectable, inject } from '@angular/core';
import { BridgeService } from '@app/services/bridge.service';
import mixpanel from 'mixpanel-browser';

@Injectable({ providedIn: 'root' })
export class MixpanelService {
    private readonly bridgeService = inject(BridgeService);

    private _userId = '';
    private _people = {};

    init(): void {
        if (this.bridgeService.isProd) {
            mixpanel.init('322ab1c9c4a98def765d1a98819d706b', {
                api_host: 'https://api-eu.mixpanel.com',
            });
        }
    }

    identify(userId: string): void {
        if (this.bridgeService.isProd) {
            mixpanel.identify(userId);
        } else {
            this._userId = userId;
        }
    }

    track(id: string, action: any = {}): void {
        if (this.bridgeService.isProd) {
            mixpanel.track(id, action);
        } else {
            console.log(
                `MixpanelService.track id: ${id} userId: ${this._userId} action: ${JSON.stringify(action)}`,
                this._people
            );
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    people_set(data: {}): void {
        if (this.bridgeService.isProd) {
            mixpanel.people.set(data);
        } else {
            this._people = data;
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    register(data: {}): void {
        if (this.bridgeService.isProd) {
            mixpanel.register(data);
        }
    }

    reset(): void {
        if (this.bridgeService.isProd) {
            mixpanel.reset();
        } else {
            this._userId = '';
            this._people = {};
        }
    }
}
